export enum MeshCellValueFormatKind
{
    // ------------------------------------

    General = 'General',
    PlainText = 'PlainText',
    MaskedText = 'MaskedText',

    // ------------------------------------

    Number  = 'Number',
    Percent = 'Percent',
    Fraction = 'Fraction',

    // ------------------------------------

    Accounting      = 'Accounting',
    Financial       = 'Financial',
    Currency        = 'Currency',
    CurrencyRounded = 'CurrencyRounded',

    // ------------------------------------

    Date     = 'Date',
    Time     = 'Time',
    DateTime = 'DateTime',
    Duration = 'Duration',
    Timestamp = 'Timestamp',

    // ------------------------------------

    Image = 'Image',
    Userdefined = 'Userdefined'

    // ------------------------------------
}




